/* eslint-disable react/prop-types */
import { Box } from "@rebass/grid";
import React from "react";
import styled from "styled-components";
import { OutageStatusNotification } from "../OutageStatusNotification";
import { getOutageNotificationVariant } from "./_/GetOutageNotificationVariant";
import { PreliminaryEtrLearnMoreLink } from "../PreliminaryEtrLearnMoreLink/PreliminaryEtrLearnMoreLink";
import { UNPLANNED } from "../OutageStatusType";

const OutageIdWrapper = styled(Box)`
  display: flex;
  align-items: flex-start;
`;

const OutageStatusWrapper = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

const KnownOutageEventNotification = ({
  outageId,
  serviceRequestNumber,
  outageStatus,
  preliminaryEtrType,
  outageStatusType,
}) => {
  const displayId = serviceRequestNumber || outageId;

  const outageNotificationVariant = getOutageNotificationVariant(
    preliminaryEtrType,
  );

  return (
    <>
      <OutageStatusNotification
        variant={outageNotificationVariant}
        notification={() => (
          <OutageStatusWrapper>
            <span data-testid="OutageStatus">{outageStatus}</span>
            {outageStatusType === UNPLANNED && (
              <PreliminaryEtrLearnMoreLink
                preliminaryEtrType={preliminaryEtrType}
                testIdPrefix="KnownOutage"
              />
            )}
          </OutageStatusWrapper>
        )}
      />

      <OutageIdWrapper py={10} pl={20}>
        <span> {`outage id: ${displayId}`} </span>
      </OutageIdWrapper>
    </>
  );
};

export default KnownOutageEventNotification;
